import { useMutation, useQuery } from '@tanstack/react-query';
import { has } from 'lodash';
import { getLiveForm, saveLiveForm, updateLiveForm } from './api';

export enum LiveFormKeys {
  getLiveForm = 'getLiveForm',
}

export type TLiveForm = {
  liveform: {
    fields: {
      id: string;
      xfdf_data: string;
      json_data: object;
      type?: string;
      is_type_signature_enabled: boolean;
    };
  };
};

export const useSaveLiveFormMutation = () =>
  useMutation({ mutationFn: saveLiveForm });
export const useUpdateLiveFormMutation = () =>
  useMutation({ mutationFn: updateLiveForm });

export const useGetLiveFormQuery = (fileId: string) =>
  useQuery({
    queryKey: [LiveFormKeys.getLiveForm, fileId],
    queryFn: async () => {
      const { data } = await getLiveForm(fileId);

      if (data && has(data, 'data')) {
        return data.data as TLiveForm;
      }
      return null;
    },
    enabled: !!fileId,
    cacheTime: 0,
  });
